// Drawer latéral
(() => {
    const body = document.body;
    function openDrawer(sel) {
        const dr = document.querySelector(sel);
        const ov = document.getElementById(sel.replace('#','') + '-overlay') || document.querySelector('.drawer-overlay');
        if (!dr) return;
        dr.classList.add('is-open');
        ov?.classList.add('is-open');
        body.classList.add('no-scroll');
    }
    function closeDrawer() {
        document.querySelectorAll('.drawer.is-open').forEach(d => d.classList.remove('is-open'));
        document.querySelectorAll('.drawer-overlay.is-open').forEach(o => o.classList.remove('is-open'));
        body.classList.remove('no-scroll');
    }
    document.addEventListener('click', (e) => {
        const openBtn = e.target.closest('[data-drawer-open]');
        const closeBtn = e.target.closest('[data-drawer-close]');
        const ov = e.target.closest('.drawer-overlay');
        if (openBtn) openDrawer(openBtn.getAttribute('data-drawer-open'));
        if (closeBtn || ov) closeDrawer();
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawer(); });
})();
